// GET PDF with Bearer token (fetch → blob → save). Callers: StudentsGrid, StudentCalculationTable, StudentPdfFilesGrid (import DownloadPdf only).
import { apiUrl } from "../config.js";
import { removeFromStorage } from "./Utility.js";

/** Applied to full optional save-as name; callers do not need to repeat this. */
function sanitizeDownloadFileName(name) {
  return String(name).replace(/[<>:"/\\|?*\u0000-\u001f]/g, "_");
}

async function WebRequestPdf(props) {
  let fullPath = props.path;
  var fullPdfpath = apiUrl + "/" + fullPath;
  let url = fullPdfpath;

  const pathSegmentName = fullPath.slice(1 + fullPath.lastIndexOf("/"));
  let fileName =
    props.downloadFileName != null && String(props.downloadFileName).length > 0
      ? sanitizeDownloadFileName(props.downloadFileName)
      : pathSegmentName;

  const loginData = JSON.parse(localStorage.getItem("login"));
  const token = loginData?.token;

  let headers = {
    Accept: "application/json, text/plain, */*",
  };

  if (token) {
    headers["Authorization"] = "Bearer " + token;
  }

  if (props.contentType) {
    headers["Content-Type"] = props.contentType;
  }

  const fetchOptions = {
    method: props.method || "GET",
    headers: headers,
  };

  if (props.method && props.method.toUpperCase() !== "GET" && props.body) {
    fetchOptions.body = JSON.stringify(props.body);
  }

  try {
    const response = await fetch(url, fetchOptions);
    if (!response.ok) {
      if (response.status === 401) {
        removeFromStorage("login"); // Assuming removeFromStorage is a function you've defined elsewhere
        window.location.href = "/login";
        return null;
      }
      throw new Error(
        `Download Error==> File ${fileName}, Status: ${response.status}`
      );
    }
    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = downloadUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(downloadUrl);
    document.body.removeChild(a);
  } catch (error) {
    console.error("Download error:", error);

    throw new Error(error);
  }
}

// path = API relative path (real file key). downloadFileName = optional “Save as” label only.
async function DownloadPdf(path, downloadFileName) {
  try {
    let props = {
      path: path,
      method: "GET",
      contentType: "application/octet-stream",
      ...(downloadFileName != null && String(downloadFileName).length > 0
        ? { downloadFileName }
        : {}),
    };
    let filePath = await WebRequestPdf(props);
    return filePath;
  } catch (error) {
    console.error(error);
    return error;
  }
}

export { DownloadPdf };
